import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import {
    fetchLatestEventsForStage,
    fetchLatestEventsForStageKey,
    fetchComingEventsForStage,
    fetchComingEventsForStageKey
} from '../../../actions/events';
import { EventsList } from 'dash-front/components/sm/pages/views/EventsList';
import SMStream from 'dash-front/components/sm/streams/SMStream2';

// GroupStageOverviewSMWidget;

let roundWidgets = (tournament, season, stage, round, events) => {
    return [
        {
            name: 'RoundMatchesSMWidget',
            groupTitle: `Round ${round}`,

            props: {
                tournamentId: tournament.id,
                stageId: stage.id,
                round
            }
        },
        ..._.chain(events)
            .groupBy(e => moment(e.startDate).format('YYYY-MM-DD'))
            .keys()
            .map(date => {
                return {
                    name: 'TodayMatchesSMWidget',
                    groupTitle: `Matchday ${moment(date).format('D MMM')}`,
                    groupKey: `${date + '_' + tournament.id}`,
                    props: {
                        tournamentId: tournament.id,
                        stageId: stage.id,
                        date: date
                    },
                    key: `${date + '_' + tournament.id}`
                };
            })
            .value()
    ];
};

let tournamentTables = (tournament, season, stage) => {
    return [
        {
            name: 'TournamentTableSMWidget',
            groupTitle: `${stage.enetPulseName}`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                full: true
            }
        },
        {
            name: 'AnimatedTournamentTable',
            // groupTitle: `${stage.enetPulseName} animation`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id
            }
        },
        {
            name: 'LeagueTrackerSMWidget',
            groupTitle: `${stage.enetPulseName} league tracker`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id
            }
        }
    ];
};

let stageMatchDays = (tournament, season, stage, events) => {
    return [
        ..._.chain(events)
            .groupBy(e => moment(e.startDate).format('YYYY-MM-DD'))
            .keys()
            .map(date => {
                return {
                    name: 'TodayMatchesSMWidget',
                    groupTitle: `Matchday ${moment(date).format('D MMM')}`,
                    groupKey: `${date + '_' + tournament.id}`,
                    props: {
                        tournamentId: tournament.id,
                        stageId: stage.id,
                        date: date
                    },
                    key: `${date + '_' + tournament.id}`
                };
            })
            .value()
    ];
};

let smallGroupOverviewWidgets = (tournament, season, stage) => {
    return [
        {
            name: 'GroupStageOverviewSMWidget',
            groupTitle: `Group Overview`,
            groupKey: `${'_' + tournament.id}`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id
            }
        },
        {
            name: 'GroupStageOverviewSMWidget',
            groupTitle: `Group + current round`,
            groupKey: `${'_' + tournament.id}-current`,
            props: {
                tournamentId: tournament.id,
                seasonId: season.id,
                stageId: stage.id,
                showMatches: 'current'
            }
        }
    ];
};

class TournamentStageSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        let { dispatch, fetchLatestEventsForStage, params } = this.props;

        dispatch(fetchLatestEventsForStage(params.stageId));
        dispatch(fetchComingEventsForStage(params.stageId));
    };

    componentWillReceiveProps = nextProps => {
        let { dispatch, fetchLatestEventsForStage, params } = this.props;

        if (+this.props.params.stageId !== +nextProps.params.stageId) {
            dispatch(fetchLatestEventsForStage(+nextProps.params.stageId));
            dispatch(fetchComingEventsForStage(+nextProps.params.stageId));
        }
    };

    renderCup = () => {
        let { tournament, season, stage } = this.props;
        return (
            <div>
                <div>If it is CUP</div>
                <SMStream
                    smWidgets={[
                        {
                            name: 'PlayoffGridSMWidget',
                            groupKey: `playoff`,
                            props: {
                                tournamentId: tournament.id,
                                seasonId: season.id,
                                stageIds: JSON.stringify([stage.id])
                            },
                            key: `tt-${season.id}-playoff`
                        }
                    ]}
                    title="Group overview"
                />
            </div>
        );
    };
    renderGroupOverview = () => {
        let { tournament, season, stage, events, comingEvents } = this.props;
        return (
            <div>
                {/* <SMStream smWidgets={basicTopList(tournament, season, events)} title="Top Lists" /> */}
                <SMStream smWidgets={smallGroupOverviewWidgets(tournament, season, stage)} title="Group overview" />

                <SMStream
                    smWidgets={stageMatchDays(tournament, season, stage, [...events, ...comingEvents])}
                    title="Group matchdays"
                />
                <div>If it is GROUP</div>
                <ul>
                    <li>Current round matches</li>
                    <li>Todays matches list</li>
                    <li>Stage top scorer</li>
                </ul>
            </div>
        );
    };
    renderLeague = () => {
        let { tournament, season, stage, comingEvents } = this.props;
        let currentRound = _.find(stage.roundsList, r => r.isCurrent);
        return (
            <div>
                <SMStream
                    smWidgets={roundWidgets(
                        tournament,
                        season,
                        stage,
                        (currentRound && currentRound.name) || tournament.currentRound,
                        comingEvents
                    )}
                    title="Current round / nearest matchdays"
                />

                <SMStream smWidgets={tournamentTables(tournament, season, stage)} title="Tournament tables" />
            </div>
        );
    };

    renderFriendliesMatches = () => {
        let { events = [], comingEvents = [] } = this.props;
        return (
            <div>
                <EventsList events={events} title="Finished events" />
                <EventsList events={comingEvents} title="Upcoming events" />
            </div>
        );
    };

    render() {
        let {
            params: { tournamentId, seasonId, sport, stageId },
            tournament,
            stage,
            events = [],
            comingEvents = []
        } = this.props;

        if (!stage) return <div />;

        if (+tournamentId === 114) return this.renderFriendliesMatches();
        return (
            <div>
                <EventsList events={events} title="Finished events" />
                <EventsList events={comingEvents} title="Upcoming events" />

                {stage.isCup && this.renderCup()}
                {stage.isCup === false && stage.roundsList.length <= 6 && this.renderGroupOverview()}
                {stage.isCup === false && stage.roundsList.length > 6 && this.renderLeague()}
            </div>
        );
    }
}

export default connect(
    (state, props) => {
        let ids = _.get(state, `query.entities[${fetchLatestEventsForStageKey(props.params.stageId)}]`, []);
        let cids = _.get(state, `query.entities[${fetchComingEventsForStageKey(props.params.stageId)}]`, []);

        let events = _.get(state, `query.entities.events`, []);

        return {
            events: ids.map(id => events[id]),
            comingEvents: cids.map(id => events[id]),
            tournament: _.get(state.smBrowser, 'tournament'),
            season: _.get(state.smBrowser, 'season'),
            stage: _.chain(state.smBrowser)
                .get('season.stages', [])
                .find(s => +s.id === +props.params.stageId)
                .value()
        };
    },
    dispatch => ({
        dispatch,
        fetchLatestEventsForStage,
        fetchComingEventsForStage
    })
)(TournamentStageSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TournamentStageSMB.js
 **/